export const AUTH_TOKEN = 'ref-67aa6160-c895-4215-91b3-6fb7631da721';
